import { ENGLISH_LOCALE } from '../../config/consts';
import { GearLocale } from '../../Model/GearLocale';
import { useGetTranslations } from '../translations/useGetTranslations';
import { useGetLocales } from './useGetLocales';
import _ from 'lodash';

interface UseTranslationResult {
  translate: (messageKey: string, params?: Record<string, string | number>) => string;
  isLoading: boolean;
  error: boolean;
}

export function useTranslation(activeLocale?: GearLocale): UseTranslationResult {
  const { data: locales } = useGetLocales();

  const englishLocale = locales?.find(locale => locale.name === ENGLISH_LOCALE || locale.name.includes(ENGLISH_LOCALE));

  const { data: activeTranslations, isLoading: isLoadingActive, error: activeError } = useGetTranslations(activeLocale);

  const needsEnglishFallback = activeLocale !== englishLocale?.name;
  const {
    data: englishTranslations,
    isLoading: isLoadingEnglish,
    error: englishError
  } = useGetTranslations(needsEnglishFallback ? englishLocale?.name : undefined);

  const isLoading = isLoadingActive || (needsEnglishFallback && isLoadingEnglish);
  const hasError = !!activeError && (!needsEnglishFallback || !!englishError);

  const translate = (messageKey: string, params?: Record<string, string | number>): string => {
    let message: string | undefined;

    if (activeTranslations) {
      message = _.get(activeTranslations, messageKey);
    }

    if (!message && englishTranslations && needsEnglishFallback) {
      message = _.get(englishTranslations, messageKey);
    }

    if (!message) {
      message = messageKey;
    }

    let finalMessage = message || messageKey;

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        finalMessage = finalMessage.replace(`{${key}}`, value.toString());
      });
    }

    return finalMessage;
  };

  return {
    translate,
    isLoading,
    error: hasError
  };
}
